import * as React from 'react';

import * as styles from './styles.css';

/** Замена задепрекейченному Header0 */
export const BigTitle = (props: { children: React.ReactNode }) => {
  return <h1 className={styles['title']}>{props.children}</h1>;
};
